module.exports = __webpack_public_path__ + "img/b-icon_plus-str.a99bb60b.svg";